import { createStateSelector } from '~/_shared/utils/memoize/createSelector';
import { isDataLayersArtificialBoundaryTerritoryGroup } from '~/sidebar/sidebarApps/mapTools/dataLayersTool/dataLayersTool.helpers';
import type { AppState } from '~/store/app.store';
import { mapSettingsDataLayerGroupsSelector } from '~/store/mapSettings/data/dataLayers/mapSettingsDataLayers.selectors';
import { mapSettingsExportImageSettingsModeSelector } from '~/store/mapSettings/toolsState/exportImageSettings/exportImageSettings.selectors';
import { isMapPresentationalSelector } from '~/store/selectors/useMapInfoSelectors';
import { isDataLayersEnabledSelector } from '~/store/userData/userData.selectors';
import { resolveActiveTool } from './mapSettingsToolsStateActiveTool.helper';
import type { MapSettingsToolsStateActiveTool } from './mapSettingsToolsStateActiveTool.state';

export const mapSettingsToolsStateActiveToolSelector = (state: AppState) =>
  state.map.mapSettings.data.toolsState.activeTool;

const boundaryTerritoryGroupsSelector = (state: AppState) => state.map.boundaryTerritoryGroups.groups;
const boundaryTerritoryGroupsLoadedSelector = (state: AppState) => state.map.boundaryTerritoryGroups.isLoaded;

export const activeToolSelector = createStateSelector([
  mapSettingsToolsStateActiveToolSelector,
  mapSettingsDataLayerGroupsSelector,
  boundaryTerritoryGroupsSelector,
  boundaryTerritoryGroupsLoadedSelector,
  isDataLayersEnabledSelector,
  isMapPresentationalSelector,
  mapSettingsExportImageSettingsModeSelector,
], (
  activeTool,
  dataLayerGroups,
  boundaryTerritoryGroups,
  areBTGsLoaded,
  isDataLayersEnabled,
  isMapPresentational,
  isImageExport,
): MapSettingsToolsStateActiveTool => resolveActiveTool({
  activeTool,
  isDataLayersEnabled,
  hasDataLayers: dataLayerGroups.length > 0,
  areBTGsLoaded,
  hasBoundaryToolBTGs: boundaryTerritoryGroups.some(btg => !isDataLayersArtificialBoundaryTerritoryGroup(btg)),
  isMapPresentational,
  isImageExport: !!isImageExport,
}));
